import React, { useMemo } from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useSearchFolder, type SearchFolder } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';
import { SearchFolderSharesSection } from './components/SearchFolderSharesSection';
import ShareSearchFolderButton from './components/ShareSearchFolderButton';
import { useAccessibleAccounts } from '../emails/useData';

const Detail: React.FC = () => {
  const { data: accessibleAccounts } = useAccessibleAccounts();

  const accountById = useMemo(() => {
    const map = new Map<number, string>();
    (accessibleAccounts ?? []).forEach((a) =>
      map.set(a.id, a.emailAddress ?? a.displayName ?? String(a.id)),
    );
    return map;
  }, [accessibleAccounts]);

  const getDetailSectionsWithShares = (
    item: SearchFolder,
    formatDate: (dateString?: string) => string,
  ) => {
    const sharesSection = {
      title: 'Shared with',
      fields: [
        {
          label: '',
          value: <SearchFolderSharesSection folder={item} />,
        },
      ],
    };

    return [sharesSection, ...getDetailSections(item, formatDate, accountById)];
  };

  return (
    <GenericDetailPage<SearchFolder>
      useData={useSearchFolder}
      config={{
        ...moduleConfig,
        detail: {
          ...moduleConfig.detail,
          getExtraHeaderActions: (item) => (
            <ShareSearchFolderButton folder={item} showLabel />
          ),
        },
        getDetailSections: getDetailSectionsWithShares,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
